import React, { useState, useContext } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import HandshakeIcon from "@mui/icons-material/Handshake";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import PaperComponent from "../../components/PaperComponent";
import {
  buscarCondicoesComerciaisPorGrupoEconomico,
  cadastrarCondicaoComercial,
  atualizarCondicaoComercial,
  excluirCondicaoComercial,
  obterCondicaoPorTextoDeBusca,
} from "../../services/api-financeiro.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import CondicaoComercialForm from "src/forms/CondicaoComercialForm";

const CondicaoComercial = () => {
  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [msg, setMsg] = useState("");

  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);

  const columns = [
    {
      id: "idCondicaoComercial",
      label: "ID",
      field: "idCondicaoComercial",
    },
    { id: "servico", label: "Serviço", field: "servico" },
    { id: "validoDe", label: "Válido De", field: "validoDe_cellVal" },
    { id: "validoAte", label: "Válido Até (Calculado)", field: "validoAte_cellVal" },
    { id: "percentual", label: "Percentual", field: "percentual", type: 'porcentagem' },
    { id: "imposto", label: "Imposto", field: "imposto", type: 'porcentagem' },
    { id: "prazo", label: "Prazo", field: "prazo" },
  ];

  const handleOpenModal = async (rowData) => {
    rowData.idCondicaoComercial !== undefined
      ? setEditRowData(rowData)
      : setEditRowData({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);

    data.condicaoComercial.idGrupoEconomico = parseInt(idGrupoEconomico);
    if (!editRowData.idCondicaoComercial) {
      await cadastrarCondicaoComercial(data)
        .then(async (response) => {
          setMsg(response.mensagem);
          await getData();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) =>
          handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
        );
    } else {
      await atualizarCondicaoComercial(
        data,
        parseInt(editRowData.idCondicaoComercial)
      )
        .then(async (response) => {
          setMsg(response.mensagem);
          await getData();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) =>
          handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
        );
    }

    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    await excluirCondicaoComercial(editRowData.idCondicaoComercial)
      .then(async (response) => {
        setMsg(response.mensagem);
        await getData();
        handleCloseDialogExclusao();
        handleOpenSnackbarSucesso();
      })
      .catch((err) =>
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      );
    setLoading(false);
  };

  const getData = async () => {
    try {
      const response = await buscarCondicoesComerciaisPorGrupoEconomico(idGrupoEconomico);
      let condicoes = response.condicoesComerciais;
      condicoes = await condicoes.map((condicao) => {
        condicao.servico = condicao.ServicosORM.descricao;
        if (condicao.validoDe) condicao.validoDe_cellVal = new Date(condicao.validoDe);
        if (condicao.validoAte)
          condicao.validoAte_cellVal = new Date(condicao.validoAte);
        return condicao;
      });
      
      condicoes = condicoes.sort((a, b) => {
        if (a.servico < b.servico) return -1;
        if (a.servico > b.servico) return 1;
        if (a.validoDe_cellVal < b.validoDe_cellVal) return -1;
        if (a.validoDe_cellVal > b.validoDe_cellVal) return 1;
        return 0;
      });

      setData(condicoes);
    } catch (err) {
      setMsg(err.mensagem);
      handleOpenSnackbarErro();
    }
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleLoginChange = (event) => {
    const loginValue = event.target.value
      .replace(/\s+/g, ".")
      .replace(/[^a-zA-Z.]/g, "")
      .replace(/\.+/g, ".")
      .toLowerCase();
    setEditRowData({ ...editRowData, login: loginValue });
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterCondicaoPorTextoDeBusca(
        event.target.value,
        idGrupoEconomico
      );
      let condicoes = response.condicoesComerciais;
      condicoes = await condicoes.map((condicao) => {
        condicao.servico = condicao.ServicosORM.descricao;
        if (condicao.validoDe) condicao.validoDe_cellVal = new Date(condicao.validoDe);
        if (condicao.validoAte)
          condicao.validoAte_cellVal = new Date(condicao.validoAte);
        return condicao;
      });
      
      condicoes = condicoes.sort((a, b) => {
        if (a.servico < b.servico) return -1;
        if (a.servico > b.servico) return 1;
        if (a.validoDe_cellVal < b.validoDe_cellVal) return -1;
        if (a.validoDe_cellVal > b.validoDe_cellVal) return 1;
        return 0;
      });
      
      setData(condicoes);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setData([]);
      } else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      }
    }
    setLoading(false);
  };

  const handleAutoCompleteGrupoEconomicoChange = async (id) => {
    setLoading(true);
    if (id) {
      const response = await buscarCondicoesComerciaisPorGrupoEconomico(id);
      let condicoes = response.condicoesComerciais;
      condicoes = await condicoes.map((condicao) => {
        condicao.servico = condicao.ServicosORM.descricao;
        if (condicao.validoDe) condicao.validoDe_cellVal = new Date(condicao.validoDe);
        if (condicao.validoAte)
          condicao.validoAte_cellVal = new Date(condicao.validoAte);
        return condicao;
      });
      setIdGrupoEconomico(id);
      setData(condicoes);
    } else {
      setIdGrupoEconomico(undefined);
      setData([]);
    }
    setLoading(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <HandshakeIcon fontSize="30px"/>
        }
        headerTitle={"Condição Comercial"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Novo"}
        customModalDisable={!idGrupoEconomico}
        AutoComplete={["GRUPOECONOMICO"]}
        handleAutoCompleteChange={handleAutoCompleteGrupoEconomicoChange}
      />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        orderColumn={"servico"}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <HandshakeIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idCondicaoComercial
                ? "Edição de Condição Comercial"
                : "Cadastro de Condição Comercial"}
            </h1>
          </div>
        </DialogTitle>
        <CondicaoComercialForm
          condicaoComercialValues={Object.assign({}, editRowData)}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        ></CondicaoComercialForm>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente a condição comercial{" "}
            {editRowData.idCondicaoComercial}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default CondicaoComercial;
